/* RESPONSIBLE TEAM: team-inbox-management */
import Rule from 'embercom/models/inbox/conversation-rules/rule';

export default Rule.extend({
  entityString: 'priority_rule',
  subRouteString: 'priorities',
  allowedRuleActions: ['change-conversation-priority'],
});
